import Vue from 'vue'
import App from './App.vue'

import {router} from "@/router";

Vue.config.productionTip = false

import "./assets/css/default.css"
import "./assets/css/main_layout.css"
import "./assets/font/xeicon.min.css"
import SetLang from "./assets/js/common"

Vue.component(SetLang)

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
